import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';

function RelativeLink({ to, ...rest }) {
  const match = useRouteMatch();

  return <Link to={`${match.url}${to}`} {...rest} />;
}
RelativeLink.propTypes = {
  to: PropTypes.string.isRequired,
};
export default RelativeLink;
